module.exports = __webpack_public_path__ + "img/data_overview_map_left.f1527f42.png";